import { EventConstants, delayedCall, dispatcher, killDelayedCall } from "@quest/base-core";
import { SettingPannelController, SlotConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist";

import { eventDispatchers } from "../Constants/EventDispatchers";
import { gameConstants } from "../Constants/gameConstants";

export class SettingPanelController extends SettingPannelController {

  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.RESIZE_SETTING_PANEL, this.resizeSettingPanelElements, this);
  }
  /**
   * Override to reset progress bar and Jackpot Meter Values
   */
  protected onMaxBetPressUp(): void {
    super.onMaxBetPressUp();
    dispatcher.fireEvent(eventDispatchers.RESET_PROGRESS_BAR_ELEMENTS);
    dispatcher.fireEvent(eventDispatchers.UPDATE_JACKPOT_METERS_VALUES);

  }

  /**
   * Override to update Jackpot Meters Values
   */
  protected onChangeStake(value: number): void {
    super.onChangeStake(value);
    dispatcher.fireEvent(eventDispatchers.UPDATE_JACKPOT_METERS_VALUES);
  }

  /**
   * Overrided to call a method which will resize bet setting panel
   */
  protected showView(): void {
    super.showView();
    this.resizeSettingsPanel();
  }

  /**
   * This method is overrided to resize the bet setting panel when it is opened from paytable
   */
  protected toggleToBetSettingsPage(): void {
    if (this.betSettingsView.style.display === SlotConstantsBehavior.DISPLAY_NONE) {
      super.toggleToBetSettingsPage()
      this.resizeSettingsPanel();
      dispatcher.fireEvent(EventConstants.BUTTON_RELESED, gameConstants.SettingButton);

    }
  }

  /**
   * This method is overrided to play button sound
   */
  protected toggleToHelpPage() {
    if (this.infoContainerDiv.style.display === SlotConstantsBehavior.DISPLAY_NONE) {
      dispatcher.fireEvent(EventConstants.BUTTON_RELESED, gameConstants.HelpPage);
      super.toggleToHelpPage();
    }
  }

  /**
   * To resize bet setting panel when it is opened for the first time
   * Bcs first time bet setting panel content is shifted upwards, to resize it this method needs to be called
   */
  private resizeSettingsPanel(): void {
    delayedCall(
      "resizeDleay",
      10,
      () => {
        killDelayedCall("resizeDleay")
        this.resizeSettingPanelElements()
      },
      this
    );
  }
  private resizeSettingPanelElements():void{
    const spC = document.getElementById("SP-Container");
    const spO = document.getElementById("SP-Options");
    const spM = document.getElementById("SP-Menu");
    const newTopPosition =
      (spC.offsetHeight - spO.offsetHeight - spM.offsetHeight) / 2 - 6;
    document.getElementById(
      "SP-Content"
    ).style.marginTop = `${newTopPosition}px`;
  }
  /**
 * added to resize view if someone zoom it in html
 */
  public hideView(): void {
    super.hideView();
    if (!ingenuity.deviceEnv.isDesktop) {
      dispatcher.fireEvent(eventDispatchers.RESIZE_CANVAS_ON_HELP_ZOOM, ingenuity.deviceEnv.update());
    }
  }
}
